export { TrainingCoachCard } from './TrainingCoachCard';
